import { Theme, useStyles } from 'bold-ui'
import { PageHeader, PageHeaderProps } from 'components/PageHeader'

import { PageContainer } from './layout/PageContainer'

export interface PageHeaderSectionProps extends PageHeaderProps {
  children?: React.ReactNode
  fluid?: boolean
}

export function PageHeaderSection(props: Readonly<PageHeaderSectionProps>) {
  const { children, fluid, ...rest } = props
  const { classes } = useStyles(createStyles, props)

  return (
    <div className={classes.wrapper}>
      <PageContainer fluid={fluid}>
        <PageHeader style={classes.pageHeader} {...rest} />

        {children}
      </PageContainer>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  wrapper: {
    background: theme.pallete.surface.main,
  },
  pageHeader: {
    paddingTop: '2rem',
    paddingBottom: '2rem',
  },
})
